import React from "react";
import close from "../../../../common/images/close.png";
var Parser = require("html-react-parser");

const CancellationPolicy = (props) => {
  const { state } = props;

  return (
    <>
      <div className="cp-header textcenter">
        <a className="date-package-popup" href={void 0}>
          <img src={close} alt="closeicon" />
        </a>
      </div>
      <div className="cp-body">
        <h4>Cancellation and Refund</h4>
        {state.cancellation_rules.length > 0 &&
          state.cancellation_rules.map((item, index) => {
            return (
              <div>
                {(() => {
                  if (index === 0) {
                    return (
                      <div>
                        <h5>Before {item.toDateDetails}</h5>
                        <p>
                          Cancellation and amendment charge is S$
                          {item.cancelCharge} & S${item.amendCharge}
                        </p>
                      </div>
                    );
                  } else if (index === 1) {
                    return (
                      <div>
                        {item.fromDateDetails !== "" &&
                          typeof item.fromDateDetails !== "undefined" &&
                          item.toDateDetails !== "" &&
                          typeof item.toDateDetails !== "undefined" && (
                            <>
                              <h5>
                                Between {item.fromDateDetails},{" "}
                                {item.toDateDetails}
                              </h5>
                              <p>
                                Cancellation and amendment charge is S$
                                {item.cancelCharge !== "" &&
                                typeof item.cancelCharge !== "undefined"
                                  ? parseFloat(item.cancelCharge).toFixed("2")
                                  : "0"}{" "}
                                & S$
                                {item.amendCharge !== "" &&
                                typeof item.amendCharge !== "undefined"
                                  ? parseFloat(item.amendCharge).toFixed("2")
                                  : "0"}
                              </p>
                            </>
                          )}
                      </div>
                    );
                  } else if (index === 2) {
                    return (
                      <div>
                        <h5>After {item.fromDateDetails}</h5>
                        {item.amendRestricted === "true" &&
                          item.cancelRestricted === "true" && (
                            <p>Non refundable</p>
                          )}
                        {item.amendRestricted === "true" &&
                          item.cancelRestricted === "false" && (
                            <p>
                              Cancellation charge is S$
                              {item.cancelCharge !== ""
                                ? parseFloat(item.cancelCharge).toFixed("2")
                                : "0"}
                            </p>
                          )}
                        {item.amendRestricted === "false" &&
                          item.cancelRestricted === "true" && (
                            <p>
                              Amendmentable charge is S$
                              {item.amendCharge !== ""
                                ? parseFloat(item.amendCharge).toFixed("2")
                                : "0"}
                            </p>
                          )}
                        <p>
                          {!item.amendRestricted && !item.cancelRestricted
                            ? `Cancellation and amendment charge is S$ ${item.amendCharge} & S$ ${item.cancelCharge}`
                            : !item.amendRestricted && item.cancelRestricted
                            ? `Cancellation restricted - non refundable and amendment charge is S$ ${item.amendCharge}`
                            : item.amendRestricted && !item.cancelRestricted
                            ? `Amendment restricted - non refundable and cancellation charge is S$ ${item.cancelCharge}`
                            : "Non refundable"}
                        </p>
                      </div>
                    );
                  } else if (index === 3 && item.noShowPolicy === "true") {
                    return (
                      <div>
                        <h5>No show policy</h5>
                        <p>
                          No show charge is S$
                          {item.charge !== ""
                            ? parseFloat(item.charge).toFixed("2")
                            : "0"}{" "}
                        </p>
                      </div>
                    );
                  }
                })()}
              </div>
            );
          })}
        {state.tariff_notes !== "" && (
          <>
            <br />
            <h4>Hotel important infromation</h4>
            {Parser(state.tariff_notes)}
          </>
        )}
      </div>
    </>
  );
};

export default CancellationPolicy;
